var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sm:container mx-8 sm:mx-auto mt-12 lg:mt-16"
  }, [_c('div', {
    ref: "tablist",
    staticClass: "h-[230px] flex justify-center items-center",
    attrs: {
      "role": "tablist",
      "aria-label": "WELL Orgs"
    }
  }, _vm._l(_vm.blok.brands, function (brand) {
    var _brand$bottom_logos;
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.selected === brand._uid,
        expression: "selected === brand._uid"
      }],
      key: brand._uid,
      staticClass: "brands w-full justify-center",
      attrs: {
        "role": "tab"
      }
    }, [_c('div', {
      staticClass: "flex w-full",
      class: [brand.top_justify || 'justify-between']
    }, _vm._l(brand.top_logos, function (logo) {
      var _logo$image, _logo$hyperlink, _logo$image2, _logo$image3;
      return _c('div', {
        key: logo._uid,
        staticClass: "flex justify-center items-center mb-12 mx-2"
      }, [_c('ElementsLink', {
        attrs: {
          "aria-label": (_logo$image = logo.image) === null || _logo$image === void 0 ? void 0 : _logo$image.alt,
          "href": (_logo$hyperlink = logo.hyperlink) === null || _logo$hyperlink === void 0 ? void 0 : _logo$hyperlink.url
        }
      }, [_c('NuxtImg', {
        staticClass: "!h-full sm:h-full",
        style: `width: ${logo.desktop_width}; height: ${logo.desktop_height}`,
        attrs: {
          "src": (_logo$image2 = logo.image) === null || _logo$image2 === void 0 ? void 0 : _logo$image2.filename,
          "alt": (_logo$image3 = logo.image) === null || _logo$image3 === void 0 ? void 0 : _logo$image3.alt,
          "sizes": "lg:100vw md:100vw sm:100vw",
          "format": "webp",
          "loading": "lazy"
        }
      })], 1)], 1);
    }), 0), _vm._v(" "), ((_brand$bottom_logos = brand.bottom_logos) === null || _brand$bottom_logos === void 0 ? void 0 : _brand$bottom_logos.length) > 0 ? _c('div', {
      staticClass: "flex w-full",
      class: [brand.bottom_justify || 'justify-center']
    }, _vm._l(brand.bottom_logos, function (logo) {
      var _logo$image4, _logo$hyperlink2, _logo$image5, _logo$image6;
      return _c('div', {
        key: logo._uid,
        staticClass: "flex justify-center items-center mx-3 mb-12"
      }, [_c('ElementsLink', {
        attrs: {
          "aria-label": (_logo$image4 = logo.image) === null || _logo$image4 === void 0 ? void 0 : _logo$image4.alt,
          "href": (_logo$hyperlink2 = logo.hyperlink) === null || _logo$hyperlink2 === void 0 ? void 0 : _logo$hyperlink2.url
        }
      }, [_c('NuxtImg', {
        staticClass: "!h-full sm:h-full",
        style: `width: ${logo.desktop_width}; height: ${logo.desktop_height}`,
        attrs: {
          "src": (_logo$image5 = logo.image) === null || _logo$image5 === void 0 ? void 0 : _logo$image5.filename,
          "alt": (_logo$image6 = logo.image) === null || _logo$image6 === void 0 ? void 0 : _logo$image6.alt,
          "format": "webp",
          "loading": "lazy"
        }
      })], 1)], 1);
    }), 0) : _vm._e()]);
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "border-b-2 border-blue-50 w-full overflow-hidden"
  }), _vm._v(" "), _c('div', {
    staticClass: "hidden md:flex md:justify-center"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('ElementsButton', {
      key: tab.id,
      class: [_vm.selected === tab.id ? 'bg-emerald-500 bg-opacity-30' : '', _vm.buttonClass],
      nativeOn: {
        "click": function ($event) {
          return _vm.setSelected(tab.id);
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]);
  }), 1), _vm._v(" "), _c('ElementsSlider', {
    staticClass: "md:hidden pb-2",
    attrs: {
      "track-class": "pb-4"
    }
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('ElementsButton', {
      key: tab.id,
      class: [_vm.selected === tab.id ? 'bg-emerald-500 bg-opacity-30' : '', _vm.buttonClass],
      nativeOn: {
        "click": function ($event) {
          return _vm.setSelected(tab.id);
        }
      }
    }, [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }